import Vue from "vue";
import App from "./App.vue";
import { Lotto } from "@/lotto";

Vue.config.productionTip = false;

const globalDataStore = {
  gathererLink: "",
  settingsOpen: false,
  loadingLottery: true,
  lottery: Lotto.loadLotto().then((lotto) => {
    globalDataStore.loadingLottery = false;
    return lotto;
  }),
  lotteryTime: 1500,
  setsToGenerate: 4,
  frameRate: 15,
};

new Vue({
  data: globalDataStore,
  render: (h) => h(App),
}).$mount("#app");
